<template>
  <div v-if="finplans.length > 0">
    <div class="row border-top" v-for="finplan in finplans" :key="finplan.id">
      <div class="progress_block w-100 d-flex flex-wrap">
        <div class="pr-1 py-0" style="width: 100%">
          <h3 class="d-flex align-items-center text-nowrap mb-2">
            План {{ finplan.title }}
            <span class="reached_check d-none ml-2"
              ><img src="images/shift/icon/reached.png" alt=""
            /></span>
          </h3>
          <div class="progress__cas">
            <span>Касса</span>
            <div class="progress">
              <v-progress-linear
                class="progress-bar"
                role="progressbar"
                height="15"
                background-color="white lighten-3"
                color="green lighten-1"
                :value="
                  (+getFinplanCurrentAmount(finplan) / +getFinplanGoal(finplan)) * 100
                "
                aria-valuemin="0"
              >
                <div class="progress-info">
                  <span class="cas-append rubl"></span>
                  <template
                    v-if="
                      getFinplanGoal(finplan) -
                        getFinplanCurrentAmount(finplan) >
                      0
                    "
                  >
                    <span class="cas-right"
                      >{{ getFinplanCurrentAmountInPercents(finplan) }}%</span
                    >
                    <span class="cas-left"
                      >осталось
                      {{
                        numberWithSpaces(
                          Math.floor(
                            getFinplanGoal(finplan) -
                              getFinplanCurrentAmount(finplan),
                            2
                          )
                        )
                      }}
                      ₽<i class="font-normal rubl"></i
                    ></span>
                  </template>
                  <template v-else-if="!getFinplanGoal(finplan)">
                    <span class="cas-left"></span>
                  </template>
                  <template v-else>
                    <span class="cas-left"
                      >план
                      {{
                        numberWithSpaces(
                          Math.abs(Math.floor(getFinplanGoal(finplan), 2))
                        )
                      }}
                      ₽ перевыполнен на
                      {{
                        numberWithSpaces(
                          Math.abs(
                            Math.floor(
                              getFinplanGoal(finplan) -
                                getFinplanCurrentAmount(finplan),
                              2
                            )
                          )
                        )
                      }}
                      ₽<i class="font-normal rubl"></i
                    ></span>
                  </template>
                </div>
              </v-progress-linear>
            </div>
          </div>
          <div class="progress__date">
            <span>Срок</span>
            <div class="progress">
              <v-progress-linear
                class="progress-bar"
                role="progressbar"
                height="15"
                :value="
                  ((finplan.duration - finplan.endsIn) / finplan.duration) * 100
                "
                background-color="white lighten-3"
                color="blue lighten-3"
              >
                <div class="progress-info">
                  <template v-if="finplan.endsIn > 0">
                    <span class="date-left"
                      >еще осталось дней: {{ finplan.endsIn }}</span
                    >
                  </template>
                  <template v-else>
                    <span class="date-left"
                      >подсчёт <i class="font-normal rubl"></i>плана
                      окончен</span
                    >
                  </template>
                </div>
              </v-progress-linear>
            </div>
          </div>
        </div>
        <!--                <div class="col pl-0">-->
        <!-- <p class="amount">1,5 млн.</p>
                                                <p class="prize">Премия</p>
                                                <p class="end__date" data-create="05/03/2020" data-date="29/03/2020"></p> -->
        <!--                </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../../plugins/axios-common'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      finplanLoading: true,
      finplans: {}
    }
  },
  async mounted() {
    if (this.shiftInfo) {
      this.loadFinplans(this.shiftInfo.basic.number)
    }
  },
  computed: {
    ...mapGetters('shift', ['shiftInfo'])
  },
  methods: {
    loadFinplans(shiftId) {
      axios.get('/api/cash/finplan/' + shiftId).then((response) => {
        this.finplans = response.data
        this.finplanLoading = false
      })
    },
    getFinplanGoal(finplan) {
      let res = finplan.workshop_groups.find((group) =>
        group.workshops.some(
          (workshop) => workshop.id == this.shiftInfo.basic.workshop_id
        )
      )
      return res.goal
    },
    getFinplanCurrentAmount(finplan) {
      let res = finplan.workshop_groups.find((group) =>
        group.workshops.some(
          (workshop) => workshop.id == this.shiftInfo.basic.workshop_id
        )
      )
      return res.currentAmount
    },
    getFinplanCurrentAmountInPercents(finplan) {
      let res = finplan.workshop_groups.find((group) =>
        group.workshops.some(
          (workshop) => workshop.id == this.shiftInfo.basic.workshop_id
        )
      )
      return res.currentAmountInPercents
    },
    numberWithSpaces(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '0'
    }
  }
}
</script>
<style scoped>
.progress_block {
  height: auto;
  padding: 3px 5px;
  width: 100%;

  /* background: linear-gradient(
        180deg,
        rgba(226, 226, 226, 0.979922) 0%,
        #fffdfd 100%
    ); */
}
@media (max-width: 1150px) {
  .progress_block {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
  }
}

.progress_block h3 {
  font-size: 12px;
  margin-bottom: 0;
  font-weight: bold !important;
}

.progress_block p {
  margin-bottom: 0;
  padding-left: 5px;
  font-size: 10px;
  font-family: 'ArialMT', sans-serif;
}

.progress_block p:nth-child(2) {
  margin-bottom: 3px;
  background: #bcd8f8;
}

.progress__cas,
.progress__date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
  font-size: 10px;
  font-family: 'ArialMT', sans-serif;
}

.progress {
  width: 85%;
}

.progress {
  position: relative;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  background: #ffffff;
  box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.5);
}

.progress-info {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  font-size: 10px;
}

.progress__date .progress-info {
  justify-content: center;
}

/*.progress__cas .progress-bar {*/
/*    background: #7fc42f;*/
/*    padding: 0;*/
/*    display: flex;*/
/*    align-items: center;*/
/*    justify-content: space-between;*/
/*}*/

/*.reached .progress__cas .progress-bar {*/
/*    background: #f8e71c;*/
/*}*/
.v-progress-linear {
  max-width: 100%;
}
.reached .prize {
  background: #f8e71c !important;
}

.reached .reached_check {
  display: block !important;
}

.progress__date .progress-bar {
  background: #9dcaff;
}

#salaryAccordeon button i {
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.transform {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.transform-180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>
